import application from "stimulus_application";
import { definitionsFromContext } from "stimulus/webpack-helpers";
import './template_live_qa_single.css';

const context = require.context('./', true, /_controller\.js$/);
application.load(definitionsFromContext(context));
